module.exports = __webpack_public_path__ + "img/04.ac7b39a1.png";